export default __webpack_public_path__ + "static/media/logo2.ce9a9a0b.png";